import { hasPermi } from '@/directive/hasPermi'

const install = function (Vue) {
  Vue.directive('hasPermi', hasPermi)
}
export default install
